import { render, staticRenderFns } from "./AccountNotifications.vue?vue&type=template&id=9a7e03e6"
import script from "./AccountNotifications.vue?vue&type=script&lang=js"
export * from "./AccountNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports